export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: 'kr' | 'jp' | 'cn';
  tags: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
}

export const categoryLabels: Record<string, string> = {
  kr: '韩漫',
  jp: '日漫',
  cn: '国漫',
};

export const mangaList: Manga[] = [
  {
    id: '1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20glowing%20purple%20eyes%20standing%20in%20a%20dungeon%20portal%20dramatic%20lighting%20action%20pose%20clean%20simple%20background%20digital%20illustration&width=400&height=560&seq=manga-kr-01&orientation=portrait',
    category: 'kr',
    tags: ['热血', '奇幻', '战斗'],
    description: '十年前，世界突然出现了连接异次元的"门"，同时觉醒了一群被称为"猎人"的超能力者。实力最弱的E级猎人成振宇，在一次地下城探险中濒临死亡，却意外获得了"玩家"系统，从此开始了惊人的升级之路。从一个被嘲笑的"人类最弱兵器"，到站在世界顶点的最强猎人，他的传奇故事就此展开。',
    status: '连载中',
    rating: 9.6,
    views: 3280000,
    chapters: Array.from({ length: 200 }, (_, i) => ({
      id: `ch1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(30 - (i % 30)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-30',
  },
  {
    id: '2',
    title: '剑尊归来',
    author: 'LEE Go-wun',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20young%20swordsman%20with%20long%20flowing%20hair%20holding%20a%20glowing%20sword%20martial%20arts%20theme%20ancient%20Chinese%20style%20robes%20misty%20mountain%20background%20clean%20art%20style&width=400&height=560&seq=manga-kr-02&orientation=portrait',
    category: 'kr',
    tags: ['武侠', '重生', '江湖'],
    description: '曾是天下第一剑的青龙剑尊，在与魔教教主一战后陨落。当他再次睁开眼，竟回到了少年时代。带着前世的记忆和剑法，他决定这一世不再重蹈覆辙。他要守护曾经的遗憾，改写命运。',
    status: '连载中',
    rating: 9.4,
    views: 2150000,
    chapters: Array.from({ length: 150 }, (_, i) => ({
      id: `ch2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(28 - (i % 28)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-28',
  },
  {
    id: '3',
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20of%20a%20beautiful%20girl%20with%20perfect%20makeup%20transformation%20before%20and%20after%20concept%20school%20uniform%20soft%20pastel%20aesthetic%20clean%20simple%20background&width=400&height=560&seq=manga-kr-03&orientation=portrait',
    category: 'kr',
    tags: ['恋爱', '校园', '美妆'],
    description: '因为长相被欺负的朱静，通过化妆技巧彻底改变了自己的外貌，成为了校园里的女神。但她内心深处仍然是不自信的普通女孩，直到遇到了两个特别的男生，她的生活发生了翻天覆地的变化。',
    status: '已完结',
    rating: 9.2,
    views: 4500000,
    chapters: Array.from({ length: 230 }, (_, i) => ({
      id: `ch3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: '2026-04-15',
    })),
    updatedAt: '2026-04-15',
  },
  {
    id: '4',
    title: '全职猎人',
    author: '富坚义博',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20of%20a%20young%20boy%20with%20spiky%20hair%20holding%20a%20fishing%20rod%20adventure%20theme%20green%20forest%20background%20classic%20shonen%20manga%20style%20clean%20illustration&width=400&height=560&seq=manga-jp-01&orientation=portrait',
    category: 'jp',
    tags: ['冒险', '热血', '经典'],
    description: '小杰为了寻找父亲金·富力士，决定参加猎人考试成为一名猎人。在旅途中，他结识了奇犽、酷拉皮卡、雷欧力等伙伴，共同面对各种危险和挑战，展开了一段充满未知的冒险之旅。',
    status: '连载中',
    rating: 9.7,
    views: 6800000,
    chapters: Array.from({ length: 400 }, (_, i) => ({
      id: `ch4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(25 - (i % 25)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-25',
  },
  {
    id: '5',
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20of%20a%20teenage%20boy%20with%20white%20hair%20and%20blindfold%20dark%20supernatural%20theme%20purple%20energy%20cursed%20spirits%20clean%20shonen%20style%20dramatic%20lighting&width=400&height=560&seq=manga-jp-02&orientation=portrait',
    category: 'jp',
    tags: ['战斗', '校园', '超能力'],
    description: '高中生虎杖悠仁偶然吞下了诅咒之王两面宿傩的手指，成为了宿傩的容器。为了收集剩余的宿傩手指，他加入了东京都立咒术高等专门学校，与伙伴们一起对抗诅咒的战斗从此开始。',
    status: '连载中',
    rating: 9.5,
    views: 5200000,
    chapters: Array.from({ length: 260 }, (_, i) => ({
      id: `ch5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(22 - (i % 22)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-22',
  },
  {
    id: '6',
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20of%20a%20family%20portrait%20spy%20father%20assassin%20mother%20telepathic%20daughter%20and%20dog%20comedy%20theme%20warm%20color%20palette%20clean%20cute%20illustration%20style&width=400&height=560&seq=manga-jp-03&orientation=portrait',
    category: 'jp',
    tags: ['搞笑', '日常', '间谍'],
    description: '代号"黄昏"的西国最强间谍，为了执行任务需要在七天内组建一个临时家庭。他找到了妻子约尔和女儿阿尼亚，但约尔其实是暗杀者，阿尼亚是会读心的超能力者。三个各怀秘密的人组成了一家人，笑料百出的日常就此展开。',
    status: '连载中',
    rating: 9.3,
    views: 4100000,
    chapters: Array.from({ length: 100 }, (_, i) => ({
      id: `ch6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(20 - (i % 20)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-20',
  },
  {
    id: '7',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20of%20a%20young%20man%20with%20supernatural%20powers%20modern%20urban%20setting%20traditional%20Chinese%20Taoist%20elements%20dynamic%20action%20pose%20clean%20digital%20illustration&width=400&height=560&seq=manga-cn-01&orientation=portrait',
    category: 'cn',
    tags: ['奇幻', '现代', '异能'],
    description: '普通大学生张楚岚在爷爷坟前遭遇僵尸袭击，被神秘少女冯宝宝所救。从此，他被迫卷入了异人的世界，开始探索爷爷留下的秘密和自己的身世之谜。异人世界的纷争与冒险，就此拉开帷幕。',
    status: '连载中',
    rating: 9.4,
    views: 3800000,
    chapters: Array.from({ length: 600 }, (_, i) => ({
      id: `ch7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(18 - (i % 18)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-18',
  },
  {
    id: '8',
    title: '斗罗大陆',
    author: '唐家三少 / 穆逢春',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20of%20a%20boy%20with%20blue%20silver%20hair%20martial%20spirit%20powers%20fantasy%20world%20theme%20ancient%20Chinese%20clothing%20dynamic%20fighting%20pose%20clean%20illustration&width=400&height=560&seq=manga-cn-02&orientation=portrait',
    category: 'cn',
    tags: ['奇幻', '热血', '修炼'],
    description: '唐门外门弟子唐三，因偷学内门绝学被追杀跳崖明志，却发现自己穿越到了另一个世界——斗罗大陆。在这里没有魔法和斗气，只有武魂。唐三带着前世记忆开始了全新的修炼之路，他要在这个世界创造属于自己的传奇。',
    status: '连载中',
    rating: 9.3,
    views: 7500000,
    chapters: Array.from({ length: 350 }, (_, i) => ({
      id: `ch8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(15 - (i % 15)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-15',
  },
  {
    id: '9',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20of%20a%20young%20man%20commanding%20ancient%20warrior%20spirits%20in%20a%20modern%20urban%20setting%20supernatural%20guardian%20theme%20dramatic%20atmosphere%20clean%20style&width=400&height=560&seq=manga-cn-03&orientation=portrait',
    category: 'cn',
    tags: ['奇幻', '战斗', '热血'],
    description: '普通女大学生夏铃收到一份奇怪的求职信后，意外闯入了罗刹街——一条连接人界与灵域的神秘街道。她遇到了这条街的镇魂将曹焱兵，从此被卷入了一个充满守护灵和邪恶势力的世界。',
    status: '连载中',
    rating: 9.1,
    views: 2900000,
    chapters: Array.from({ length: 380 }, (_, i) => ({
      id: `ch9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(12 - (i % 12)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-12',
  },
  {
    id: '10',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20man%20reading%20a%20novel%20as%20the%20world%20ends%20apocalyptic%20theme%20constellations%20in%20the%20sky%20dramatic%20orange%20and%20dark%20tones%20clean%20art&width=400&height=560&seq=manga-kr-10&orientation=portrait',
    category: 'kr',
    tags: ['奇幻', '末世', '系统'],
    description: '金独子是唯一一个读完了一部长达3149话的冷门网络小说的人。当小说中的末日场景在现实中真实上演时，他成为了这个世界上唯一知道接下来会发生什么的人。利用书中的知识，他踏上了在末日中生存的道路。',
    status: '连载中',
    rating: 9.5,
    views: 2650000,
    chapters: Array.from({ length: 180 }, (_, i) => ({
      id: `ch10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(10 - (i % 10)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-10',
  },
  {
    id: '11',
    title: '电锯人',
    author: '藤本树',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20of%20a%20young%20man%20with%20chainsaw%20arms%20and%20head%20dark%20gritty%20style%20urban%20horror%20theme%20red%20and%20black%20color%20scheme%20bold%20clean%20illustration&width=400&height=560&seq=manga-jp-11&orientation=portrait',
    category: 'jp',
    tags: ['黑暗', '战斗', '奇幻'],
    description: '背负着亡父巨额债务的少年淀治，与恶魔波奇塔一起过着穷困潦倒的生活。在一次被黑帮背叛后，濒死的他与波奇塔合为一体，成为了"电锯人"。加入公安对魔特异4课后，他开始了与恶魔战斗的新生活。',
    status: '连载中',
    rating: 9.4,
    views: 3600000,
    chapters: Array.from({ length: 180 }, (_, i) => ({
      id: `ch11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(8 - (i % 8)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-08',
  },
  {
    id: '12',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20of%20a%20beautiful%20fox%20spirit%20girl%20in%20traditional%20red%20Chinese%20dress%20romance%20fantasy%20theme%20ancient%20Chinese%20aesthetic%20soft%20colors%20clean%20illustration&width=400&height=560&seq=manga-cn-12&orientation=portrait',
    category: 'cn',
    tags: ['恋爱', '奇幻', '古风'],
    description: '在人妖共存的世界上，狐妖红娘涂山苏苏专门为人与妖牵线搭桥。每一段跨越生死的爱情故事，都在她的帮助下得到圆满的结局。千年轮回，唯爱永恒。这是一个关于爱情与守护的温暖故事。',
    status: '连载中',
    rating: 9.2,
    views: 3200000,
    chapters: Array.from({ length: 500 }, (_, i) => ({
      id: `ch12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-07-${String(5 - (i % 5)).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-05',
  },
];